import { styled } from '@mui/material/styles';

export const StyledRoot = styled('div')(({ theme }) => ({
  // Flow under NavBarContent; CourseDocument is the scrollport.
  flex: '0 0 auto',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'visible',

  '& .MuiTab-labelIcon': {
    minHeight: 50,
  },

  '@media print': {
    position: 'relative',
    overflow: 'visible',
    height: 'auto',
  },

  '& .content': {
    padding: theme.spacing(2),

    '& .buttonRow button': {
      margin: theme.spacing(1),
    },
  },
}));

export const StyledQuestionsContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ theme, isMobile }) => ({
  flex: '0 0 auto',
  width: '100%',
  maxWidth: '1040px',
  margin: '0 auto',
  position: 'relative',
  alignSelf: 'stretch',
  overflow: 'visible',
  minHeight: 'calc(100vh - 180px)',
  display: 'flex',
  flexDirection: 'column',

  '& .assessmentContainer': {
    width: '100%',
    position: 'relative',
    overflow: 'visible',
    flex: '1 1 auto',
  },

  '& .assessmentTitle': {
    margin: theme.spacing(2),
  },

  '&.resultsContainer': {
    width: `min(1040px, calc(100% - ${theme.spacing(4)}))`,
    maxWidth: '1040px',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginLeft: 'auto',
    marginRight: 'auto',
    boxSizing: 'border-box',

    '& .questionContainer': {
      width: isMobile ? '100%' : '40%',
    },

    '& .answerContainer': {
      width: isMobile ? '80%' : '50%',
      maxWidth: 500,
      margin: theme.spacing(2),
      padding: theme.spacing(1),
      backgroundColor: theme.palette.action.disabledBackground,
      borderRadius: theme.spacing(1),
    },

    '& .question': {
      flex: 1,
      maxWidth: 500,
      margin: `${theme.spacing(5)} 0`,
      minHeight: 'auto',
    },

    '& .showAnswer': {
      '& .checkpointOption': {
        backgroundColor: theme.palette.action.disabledBackground,
        margin: `${theme.spacing(1)} ${theme.spacing(1)} 0 0`,
        padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,

        '&.incorrect': {
          '&.selected': {
            backgroundColor: theme.palette.error.main,
          },

          '& .MuiIcon-root': {
            color: theme.palette.error.main,
          },
        },
        '&.correct': {
          '&.selected': {
            backgroundColor: theme.palette.success.main,
          },

          '& .MuiIcon-root': {
            color: theme.palette.success.main,
          },
        },

        '& .MuiIcon-root': {
          padding: theme.spacing(1),
        },

        '&.selected.incorrect .MuiIcon-root, &.selected.correct .MuiIcon-root': {
          color: theme.palette.common.white,
        },
      },
    },
  },

  '& .buttonContainer': {
    position: 'sticky',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1100,
    backgroundColor: theme.palette.background.paper,
  },

  '& .buttonRow': {
    width: '100%',
    '& button': {
      margin: theme.spacing(1),
    },
  },

  '& .prog': {
    width: isMobile ? '95%' : '100%',
    maxWidth: 500,
  },
  '& .question': {
    maxWidth: 500,
    margin: '0 auto',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),

    '&.assessmentEnd': {
      textAlign: 'center',
      '& .submitRow': {
        flexDirection: 'column',

        '& .btn': {
          marginTop: theme.spacing(2),
          marginBottom: theme.spacing(2),
          width: 250,
          textAlign: 'center',

          '& button': {
            margin: theme.spacing(1),
          },
        },
      },
    },

    '&.intro': {
      textAlign: 'center',
      minHeight: undefined,

      '& .header': {
        paddingTop: theme.spacing(3),
      },
    },

    '& .submitRow': {
      marginTop: theme.spacing(2),
    },

    '& .header': {
      marginBottom: theme.spacing(2),
    },
    '& .options': {
      margin: theme.spacing(2),

      '&.boolean': {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',

        '& .checkpointOption': {
          paddingRight: theme.spacing(2),
        },
      },
    },
    '& .checkpointOption': {
      borderRadius: theme.spacing(1),
      '&:hover': {
        backgroundColor: isMobile ? undefined : theme.palette.action.disabledBackground,
        cursor: 'pointer',
      },
    },
  },
}));
